<tiime-input-container
  contentId="task"
  [label]="label"
  [small]="small"
  [required]="required"
  [errorMessage]="errorMessageMode === 'label' && errorMessage?.message"
>
  <tiime-select
    id="task"
    [class.selected]="control.value"
    [customFindOriginValueFromOptions]="findOriginValueFromOptionsById"
    [formControl]="control"
    (selectionChange)="emitSelectionChange($event)"
    (closeOptionsPanel)="closeOptionsPanel()"
  >
    <input tiimeSelectInput [formControl]="searchControl" appFormFocusObserve (formChanges)="searchControlChanges()" />
    <div tiimeSelectOptions>
      @if (!searchControl.value && allowEmpty) {
        <mat-option [value]="null"></mat-option>
      }
      @for (taskCategory of filteredSelectorData; track trackByIndex($index)) {
        <div class="divider sticky-30">
          {{ taskCategory.category.wording }}
        </div>
        @for (task of taskCategory.tasks; track trackById($index, task)) {
          <mat-option [value]="task">
            {{ task | timeTrackingTaskLabel }}
          </mat-option>
        }
      }
    </div>
  </tiime-select>
</tiime-input-container>
@if (errorMessageMode === 'list' && errorMessage) {
  <app-list-error [errorMessage]="errorMessage"></app-list-error>
}
